export default "__VITE_ASSET__CZtVpTHJ__"